//----------------------------------------------------------------------
//	DONWLOAD STICKY
//	Custom Package
//----------------------------------------------------------------------

var DownloadSticky = {
	selector: '[data-download]',
	selectorButton: '.button-download',
	isSticky: false,
	isEndPoint: false,
	isDisabled: false,
	classActive: 'container-download--active',
	classAbsolute: 'container-download--absolute',
	classOpen: 'container-download--open',
	endPointClass: 'endpoint',
	headerHeight: 0,
	selectorWidth: 0,
	contentWidth: 0,
	viewPortHeight: 0,
	offsetElRound: 0,
	endStickyPosition: 0,
	startPosition: 0,
	rightPosition: 0,
	footerHeight: 0,
	footerPosition: 0,
	windowSize: 0,
	winScroll: 0,

	init: function () {
		// return if the container not present
		if (!$(this.selector).length) return;
		this.bindChangeEvent();
		this.getWindowSize();
		this.getElSize();
		this.checkOffsetEl();
		this.setPosition();
		this.bindHoverEvent();
		this.bindKeyboardEvent();
		this.bindClickEvent();
	},

	bindChangeEvent: function () {

		// reset the functions and recalculate the values
		$(window).on('orientationchange resize load', function () {

			if (DownloadSticky.windowSize !== window.innerWidth) {

				// Update variables
				DownloadSticky.getWindowSize();
				DownloadSticky.getElSize();
				DownloadSticky.checkOffsetEl();
				DownloadSticky.setPosition();

			}

		});

	},

	checkOffsetEl: function () {

		// get the section offset position and the height of each top elements
		var offsetEl = $(DownloadSticky.selector).offset().top;
		DownloadSticky.offsetElRound = Math.round(offsetEl),
		DownloadSticky.startPosition = DownloadSticky.offsetElRound - DownloadSticky.footerHeight - 200;
		var footerPosition = $('.global-footer').offset().top;
		DownloadSticky.footerPositionRound = Math.round(footerPosition),
		DownloadSticky.endPointPosition = DownloadSticky.footerPositionRound - 400;
		var elRightPosition = (DownloadSticky.windowSize / 2 - DownloadSticky.contentWidth / 2) - DownloadSticky.selectorWidth - 90;
		DownloadSticky.rightPosition = elRightPosition;
	},

	removeHideClass: function () {
		$(DownloadSticky.containerPercentage).removeClass('hide');
	},

	getElSize: function () {

		DownloadSticky.headerHeight = $('.global-header').height(),
			DownloadSticky.contentWidth = $('.container').outerWidth(),
			DownloadSticky.footerHeight = $('.global-header').outerHeight(),
			DownloadSticky.selectorWidth = $(DownloadSticky.selector).outerWidth(),
			DownloadSticky.elHeight = $(DownloadSticky.selector).outerHeight();
	},

	getWindowSize: function () {
		// get window width and update the global value
		DownloadSticky.windowSize = window.innerWidth;
	},

	setPosition: function () {

		// set position if the view is tablet and laptop layout
		if (DownloadSticky.windowSize >= 720 && DownloadSticky.windowSize <= 1580) {
			DownloadSticky.addAbsoluteClass();
			$(DownloadSticky.selector).css('top', DownloadSticky.offsetElRound);
		}

		// set the right posion Xlarge desktop layout
		if (DownloadSticky.windowSize >= 1790) {
			$(DownloadSticky.selector).css('right', DownloadSticky.rightPosition);

		} else {
			$(DownloadSticky.selector).css('right', '0');
		}


		$(window).on('scroll', function () {
			if (DownloadSticky.windowSize >= 720) {

				if (!DownloadSticky.isDisabled === true) {

					// get scrolling position
					var winScroll = $(window).scrollTop(),
						winScrollRound = Math.round(winScroll);

					//add and remove sticky class if the scrolling position is greater than offset position
					if (winScrollRound >= DownloadSticky.startPosition) {


						if (DownloadSticky.isEndPoint === false) {

							DownloadSticky.addStickyClass();
							DownloadSticky.removeAbsoluteClass();

						}

						if (winScrollRound > DownloadSticky.endPointPosition) {

							DownloadSticky.removeStickyClass();
							DownloadSticky.addEndPointClass();
							$(DownloadSticky.selector).css('top', DownloadSticky.endPointPosition + DownloadSticky.elHeight);


						} else {
							DownloadSticky.removeEndPointClass();
							$(DownloadSticky.selector).css('top', '200px');

						}

					} else {

						DownloadSticky.removeStickyClass();
						DownloadSticky.addAbsoluteClass();
						$(DownloadSticky.selector).css('top', 'auto');
					}

				}

			} else {

				$(DownloadSticky.selector).css('top', 'auto');
			}

		});

	},

	bindHoverEvent: function () {

		$(DownloadSticky.selectorButton).on('mouseenter keyup', function (e) {

			DownloadSticky.addOpenClass();

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();
		});

	},

	bindClickEvent: function () {

		$('.button-close').on('click', function (e) {

			DownloadSticky.isDisabled = true;
			DownloadSticky.removeStickyClass();
			DownloadSticky.removeOpenClass();

			$(DownloadSticky.selector).attr('style', '');
			DownloadSticky.setPosition();

			if (DownloadSticky.windowSize >= 720 && DownloadSticky.windowSize <= 1580) {
				DownloadSticky.addAbsoluteClass();
				$(DownloadSticky.selector).css('top', DownloadSticky.offsetElRound);
			}

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();
			return false;
		});

		// if user click outsidde the content area to hide modal
		$('body').on('click', function (e) {

			var $thisTarget = $(e.target)[0];

			if ($thisTarget.closest('.button-download') !== $(DownloadSticky.selectorButton)[0]) {
				DownloadSticky.removeOpenClass();
			}

		});

	},

	bindKeyboardEvent: function () {

		$('.button-close').on('keydown', function (e) {

			if (e.key === 'Enter') {
				DownloadSticky.isDisabled = true;
				DownloadSticky.removeStickyClass();
				DownloadSticky.removeOpenClass();

				$(DownloadSticky.selector).attr('style', '');
				DownloadSticky.setPosition();
			}

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();
			return false;
		});

	},

	addStickyClass: function () {
		DownloadSticky.isSticky = true;
		$(DownloadSticky.selector).addClass(DownloadSticky.classActive);
	},

	removeStickyClass: function () {
		DownloadSticky.isSticky = false;
		$(DownloadSticky.selector).removeClass(DownloadSticky.classActive);
	},

	addEndPointClass: function () {
		DownloadSticky.isEndPoint = true;
		$(DownloadSticky.selector).addClass(DownloadSticky.endPointClass);
	},

	removeEndPointClass: function () {
		DownloadSticky.isEndPoint = false;
		$(DownloadSticky.selector).removeClass(DownloadSticky.endPointClass);
	},

	addAbsoluteClass: function () {
		$(DownloadSticky.selector).addClass(DownloadSticky.classAbsolute);
	},

	removeAbsoluteClass: function () {
		$(DownloadSticky.selector).removeClass(DownloadSticky.classAbsolute);
	},

	addOpenClass: function () {
		$(DownloadSticky.selector).addClass(DownloadSticky.classOpen);
	},

	removeOpenClass: function () {
		$(DownloadSticky.selector).removeClass(DownloadSticky.classOpen);
	}
};

$(document).ready(function () {
	DownloadSticky.init();
});